<!-- echartscom.vue -->
<template>
	<!-- <div class="charttest" > -->
		<div   style="width: 400px;height: 200px;" :id="echarts" class="echarts" ref="echarts">
		<!-- </div> -->
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import {formatDate} from './dataUtil.js';
	export default {
		name: 'echartscom',
		props: {
			chartData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				test:"ttttt",
				pay: [],
				raw: [],
				ts: [],
				myChart:null
			};
		},
		created() {
			
		},
		methods: {
			chartResize(){
			        let eleArr = [this.myChart];
			        for(let i = 0; i<eleArr.length; i++){
			          //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
			          setTimeout(function(){
			              eleArr[i].resize();
			          }, 200);
			        }
			    },
			setValue(){
				this.test="test"
				console.log()
				let data=this.chartData
				for (let item in data) {
					this.pay.unshift(data[item].hs2)
					this.raw.unshift(data[item].hs)
					this.ts.unshift(formatDate(data[item].ts))
				}
				
				
			},
			drawCharts() {
				// this.$data.myChart
				this.$data.myChart = echarts.init(document.getElementById(this.echarts));
				this.$data.myChart.setOption({
					color: ['#c0e7ff', '#adebb7', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83',
						'#bda29a',
						'#6e7074', '#546570', '#c4ccd3'
					],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					legend: {
						data: ['pay算力', 'raw算力'],

					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: this.ts
					},
					yAxis: [{
							type: 'value',
							// name: "pay算力",
							axisLabel: {
								formatter: function(value) {
									if (value >= 1 && value < 1000) {
										// texts.push(value + 'H/s')
										return value.toFixed(2) + 'H/s'
									} else if (value >= 1000 && value < 1000000) {
										return (value / 1000).toFixed(2) + 'KH/s'
									} else if (value >= 1000000 && value < 1000000000) {
										return (value / 1000000).toFixed(2) + 'MH/s'
									} else if (value >= 1000000000 && value < 1000000000000) {
										return (value / 1000000000).toFixed(2) + 'GH/s'
									} else if (value >= 1000000000000) {
										return (value / 1000000000000).toFixed(2) + 'TH/s'
									} else if (value == 0) {
										return (0)
									}
								}
							}

						},
						{
							type: 'value',
							// name: "raw算力",
							axisLabel: {
								formatter: function(value) {
									if (value >= 1 && value < 1000) {
										// texts.push(value + 'H/s')
										return value.toFixed(2)+ 'H/s'
									} else if (value >= 1000 && value < 1000000) {
										return (value / 1000).toFixed(2) + 'KH/s'
									} else if (value >= 1000000 && value < 1000000000) {
										return (value / 1000000).toFixed(2) + 'MH/s'
									} else if (value >= 1000000000 && value < 1000000000000) {
										return (value / 1000000000).toFixed(2) + 'GH/s'
									} else if (value >= 1000000000000) {
										return (value / 1000000000000).toFixed(2) + 'TH/s'
									} else if (value == 0) {
										return (0)
									}
								}
							}
						}
					],
					series: [{
							name: 'pay算力',
							type: 'line',
							data: this.pay,
							smooth: true
						},
						{
							name: 'raw算力',
							type: 'line',
							data: this.raw,
							smooth: true
						}
					]
				});
			// setTimeout(() => {
			//     window.addEventListener('resize', () => {
			//         this.$data.myChart.resize();
			//     })
			// }, 20)
			
			},

			               

		},
		computed: {
			echarts() {
				return 'echarts' + Math.random() * 100000;
			}
		},
		mounted() {
			window.addEventListener("resize", this.chartResize);
			this.setValue();
			
			this.drawCharts();
			
		},
		
		components: {}
	};
</script>

<style></style>
